import { IDashboardLayout } from 'app/components/Visualization/CDashboard/types';

import { availableWidgets1 } from './widget';

export const dashboardWidgets1: IDashboardLayout = {
  id: 'dashboard_1',
  title: 'Dashboard Title',
  widgets: [
    {
      type: 'card',
      i: 'policies',
      x: 0,
      y: 0,
      w: 1.8,
      h: 3,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'totalEntities',
      x: 1.8,
      y: 0,
      w: 1.8,
      h: 3,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'policyExceptions',
      x: 3.6,
      y: 0,
      w: 1.8,
      h: 3,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'resourceExceptions',
      x: 5.4,
      y: 0,
      w: 1.8,
      h: 3,
      isResizable: false,
      static: true,
    },
    {
      type: 'card',
      i: 'passedChecks',
      x: 7.2,
      y: 0,
      w: 4.8,
      h: 3,
      isResizable: false,
      static: true,
    },
  ],
  available: availableWidgets1,
};
